import { AboveRightBarTabs, ScheduleCodeDisplay, ScheduleIntroductionTitleTop } from "slot-definitions"
import { registerTab } from "lib/@components/tabs"
import { REGIME_ASSETS_TAB } from "routes/asset-register/plugins/regime-display/regime-display.runtime"
import { ShareLinkCommentsTabRegistrar } from "./share-link-comments-tab-registrar"
import { ShareLinkCommentsRegimePanel } from "./share-link-comments-regime-panel"
import { ShareRegimeCommentsTabLabel } from "./share-regime-comments-tab-label"
import { ScheduleBottom } from "routes/schedule/scheduleIntroduction"
import { ShareLinkCommentTargetButton } from "./share-link-comment-target-button"
import { ShareLinkSelectionCommentButton } from "./share-link-selection-comment-button"
import { ScheduleCommentIndicator } from "./share-link-comment-schedule-indicator"
import { FEATURE_FLAG_SHARE_LINK_COMMENTS } from "./share-link-comments-feature-flag"
import "./feature-flag-share-link-regime-reset"
import { isEnabled } from "lib/@components/feature"

// The "Allow comments" toggle now renders directly on the share-link Detail step
// (routes/sharing/link-step-detail.js) as a full-width card, so it is no longer plugged
// into the ShareLinkOtherSettings slot. ShareLinkCommentsSetting self-gates on the feature flag.
AboveRightBarTabs.plug(<ShareLinkCommentsTabRegistrar priority={140} />)
// Regime-level "Comments" tab now lives in the TOP regime tab bar (Schedules / Assets / Overview / …),
// alongside Unspecified Frequencies etc. The panel resolves its regime from the same bound context the
// other REGIME_ASSETS_TAB tabs read (parentItem + PlanRoot tree), so no extra <Bound> wrapper is needed.
// `data-cy` is auto-generated by registerTab (`shareLinkComments-regimeAssets-tab`); the panel itself
// carries `data-cy="share-link-regime-comments-panel"`.
registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "share-link-comments",
    title: <ShareRegimeCommentsTabLabel />,
    // Hidden for share-link visitors: recipients reach comments via the landing panel and
    // the folder/schedule indicators, not the regime-level Comments tab
    predicate: (context) => isEnabled(FEATURE_FLAG_SHARE_LINK_COMMENTS) && !context?.isShare,
    content: <ShareLinkCommentsRegimePanel $lazy priority={150} />,
})
// Recipient-facing comment entry point for the schedule introduction. Task comments are created by
// selecting a specific task part, so task rows do not need their own standalone comment button.
ScheduleIntroductionTitleTop.plug(<ShareLinkCommentTargetButton priority={140} />)
// Medium-style floating comment-on-selection button. Plugged into ScheduleBottom because that slot
// renders inside the `.schedule-details` content body with `schedule`/`schedulePath`/`isShare` in the
// bound context, giving the selection→task/intro mapping access to the schedule's task objects. It
// self-gates on the link's allowComments, so recipients without the feature demand still get it.
ScheduleBottom.plug(<ShareLinkSelectionCommentButton priority={140} />)
ScheduleCodeDisplay.plug(
    <ScheduleCommentIndicator $lazy priority={50} if={() => isEnabled(FEATURE_FLAG_SHARE_LINK_COMMENTS)} />
)
